import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

const token = localStorage.getItem('authToken');

class AddMagzines extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textInput: null, // Image file
      pdfInput: null,  // PDF file
      title: "",       // Replaced 'userName' with 'title'
      submissionStatus: null,
      currentImageUrl: null,
      submeet: false,
      errors: [],
      maxSize: 5 * 1024 * 1024, // 5MB in bytes
    };
  }

  handleChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];
    const errors = [];

    if (file) {
      if (file.size > this.state.maxSize) {
        errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
      } else if (name === "textInput") {
        this.setState({
          textInput: file,
          currentImageUrl: URL.createObjectURL(file), // Update current image URL to show the new image
        });
      } else if (name === "pdfInput") {
        if (file.type !== "application/pdf") {
          errors.push(`Invalid file type. Please select a PDF file.`);
        } else {
          this.setState({ pdfInput: file });
        }
      }
    }

    this.setState({ errors });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ submeet: true });

    const { textInput, pdfInput, title } = this.state;

    if (!textInput || !title) {
      return;
    }

    try {
      const formData = new FormData();
      formData.append('image', textInput);
      if (pdfInput) {
        formData.append('pdf', pdfInput); // Append PDF file to FormData
      }
      formData.append('title', title); // Replaced 'name' with 'title'

      const response = await axios.post("https://samaj.aasmo.in/api/admin/magazines", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 201) {
        this.setState({ submissionStatus: 'success', submeet: false });
        setTimeout(() => {
          this.props.history.push("/magazines-list");
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      this.setState({ submissionStatus: 'error' });
    }
  };

  render() {
    const { textInput, title, submeet, currentImageUrl, submissionStatus } = this.state;
    const isTitleValid = title.trim().length > 0;

    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Add Magazines</h2>
          </div>
          <div className="body">
            <form onSubmit={this.handleSubmit}>
              <div className="form-group">
                <label>Image</label>
                {currentImageUrl && (
                  <div>
                    <img src={currentImageUrl} alt="Current" style={{ width: '100px', marginBottom: '10px' }} />
                  </div>
                )}
                <input
                  type="file"
                  className={`form-control ${!textInput && submeet && "parsley-error"}`}
                  name="textInput"
                  required=""
                  onChange={this.handleChange}
                />
                {!textInput && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label>PDF</label>
                <input
                  type="file"
                  className={`form-control ${this.state.errors.length > 0 && "parsley-error"}`}
                  name="pdfInput"
                  accept="application/pdf" // Restrict file types to PDF
                  onChange={this.handleChange}
                />
                {this.state.errors.length > 0 && (
                  <ul className="parsley-errors-list filled">
                    {this.state.errors.map((error, index) => (
                      <li key={index} className="parsley-required">{error}</li>
                    ))}
                  </ul>
                )}
              </div>

              <div className="form-group">
                <label>Title</label>
                <input
                  className={`form-control ${!isTitleValid && submeet && "parsley-error"}`}
                  value={title}
                  name="title"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ title: e.target.value });
                  }}
                />
                {!isTitleValid && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>

              {submissionStatus === 'success' && (
                <div className="alert alert-success" role="alert">
                  Form submitted successfully!
                </div>
              )}

              <button className="btn btn-primary" type="submit">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default withRouter(connect(mapStateToProps, { notifyGeneralInfo })(AddMagzines));
